import {Component, Inject, OnInit} from '@angular/core';
import { FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule, FormGroup } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import {setupUntilDestroy} from '@portal-workspace/grow-ui-library';
import { Subscription } from 'rxjs';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {Application, CreditDeclineDialogData, CreditDeclineDialogResult, accreditationDeclineReasonOptions, creditDeclineCategoryOptions, withdrawApplicationReasonOptions} from '@portal-workspace/grow-shared-library';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatOptionModule } from '@angular/material/core';

import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@UntilDestroy()
@Component({
    templateUrl: './credit-decline.dialog.html',
    styleUrls: ['./credit-decline.dialog.scss'],
    standalone: true,
    imports: [MatFormFieldModule, MatSelectModule, FormsModule, MatInputModule, ReactiveFormsModule, MatOptionModule, FlexModule, MatButtonModule, MatDialogModule]
})
export class CreditDeclineDialog implements OnInit {

  formControlReasonSelection!: FormControl<string | null>;
  formControlReason!: FormControl<string | null>;
  formControlCategory!: FormControl<'Credit Declined' | 'Withdrawn' | null>;
  subscription?: Subscription;
  application!: Application;
  reasonOptions: { value: string, label: string }[] = [];
  categoryOptions = creditDeclineCategoryOptions;
  formGroup!: FormGroup<{
    reasonSelection: FormControl<string | null>,
    reason: FormControl<string | null>,
    category: FormControl<'Credit Declined' | 'Withdrawn' | null>,
  }>;

  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) data: CreditDeclineDialogData,
    private dialogRef: MatDialogRef<CreditDeclineDialog, CreditDeclineDialogResult>,
  ) {
    this.formControlReason = this.formBuilder.control(null, [Validators.required, Validators.max(10000)]);
    this.formControlReasonSelection = this.formBuilder.control(null, [Validators.required]);
    this.formControlCategory = this.formBuilder.control(null, [Validators.required]);
    this.formGroup = formBuilder.group({
      reasonSelection: this.formControlReasonSelection,
      reason: this.formControlReason,
      category: this.formControlCategory,
    })
  }

  ngOnInit(): void {
    setupUntilDestroy(this);

    this.formControlCategory.valueChanges.subscribe(value => {
      if (value === 'Credit Declined') {
        this.reasonOptions = accreditationDeclineReasonOptions;
      } else if (value === 'Withdrawn') {
        this.reasonOptions = withdrawApplicationReasonOptions.map(reason => ({ value: reason, label: reason }));
      }
      // Each category has its own reasons; one picked under the other is rejected.
      this.formControlReasonSelection.setValue(null);
    })
  }

  onSubmit(readyForSubmission: boolean) {
    if (readyForSubmission) {
      this.dialogRef.close({
        readyForSubmission,
        reasonSelection: this.formControlReasonSelection.value ?? '',
        reason: this.formControlReason.value ?? '',
        category: this.formControlCategory.value ?? 'Credit Declined',
      })
    } else {
      this.dialogRef.close()
    }
  }
}
